import { formatDurationRussian } from '@/utils/formatDurationRussian';
import { parseDuration } from '@/utils/parseDuration';
import { parseTimeExpression } from '@/utils/parseTimeInput';

const ZERO = /^\s*0+\s*[чмhm]?\s*$/i;

/** Минуты → ISO 8601 только из часов и минут, как требует контракт: 90 → `PT1H30M` */
export const toIsoDuration = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;

  return `PT${hours ? `${hours}H` : ''}${rest || !hours ? `${rest}M` : ''}`;
};

/** «2ч 30м» → минуты; в отличие от общего парсера понимает ноль (остаток оценки бывает нулевым). null — не разобрали */
export const parseDurationText = (text: string): number | null =>
  ZERO.test(text) ? 0 : parseTimeExpression(text);

/** 90 → «1ч 30м», ноль — «0ч», а не пустая строка */
export const formatMinutes = (minutes: number): string => formatDurationRussian(minutes) || '0ч';

/** `PT1H30M` → «1ч 30м». Импортированный `spent` бывает отрицательным (`-PT1H`) → «−1ч» */
export const formatIsoDuration = (duration: string): string => {
  const text = formatMinutes(parseDuration(duration.replace(/^-/, '')));

  return duration.startsWith('-') ? `−${text}` : text;
};

/** Оценка или затраченное: нет значения — «—» */
export const formatEstimation = (duration: string | null): string =>
  duration === null ? '—' : formatIsoDuration(duration);
